// extracted by mini-css-extract-plugin
module.exports = {"nav-button":"SideNavigationButton-module__nav-button__3I_Hr","selected":"SideNavigationButton-module__selected__3aG1u"};